import authentication from './authentication'
import categories from './categories'
import ceos from './ceos'
import twitter from './twitter'
import nominees from './nominees'

export default {
  authentication,
  categories,
  ceos,
  twitter,
  nominees
}
